const mutations = {
    COMMIT_NOTIFICATIONS: (state, payload) => {
        let notifications = state.notifications
        notifications.unshift(payload)
        localStorage.setItem('notifications', JSON.stringify(notifications))
        state.notifications = notifications
    },

    COMMIT_CLEAR_NOTIFICATIONS: (state) => {
        state.notifications = []
        localStorage.removeItem('notifications')
    },
}

export default mutations
